import { SCREEN_RESIZE, SET_DRAWER_OPEN } from '../actions/uiActions';
import { MOBILE_WIDTH, FULL_WIDTH } from '../../constants';
import { RAIL_WIDTH } from '../../constants/tokens';

const measure = (width) => ({
  isMobile: width <= MOBILE_WIDTH,
  isFullWidth: width >= FULL_WIDTH,
  // At or above this the persistent left rail replaces the drawer.
  isRail: width >= RAIL_WIDTH
});

const initialState = {
  windowSize: {
    width: window.innerWidth,
    height: window.innerHeight
  },
  ...measure(window.innerWidth),
  drawerOpen: false
};

const ui = (state = initialState, action) => {
  switch (action.type) {
    case SCREEN_RESIZE: {
      const next = measure(action.width);
      return {
        ...state,
        windowSize: {
          width: action.width,
          height: action.height
        },
        ...next,
        // Resizing up to the rail breakpoint leaves the drawer stranded open
        // behind the rail, so close it on the way through.
        drawerOpen: next.isRail ? false : state.drawerOpen
      };
    }
    case SET_DRAWER_OPEN:
      return {
        ...state,
        drawerOpen: action.open
      };
    default:
      return state;
  }
};

export default ui;
